import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 1,
  class: "meltingspot-widget meltingspot-widget--decorative"
}

import { onMounted, onBeforeUnmount, inject } from 'vue';
import { useMeltingSpot } from 'composables/useMeltingSpot';
import { Translator } from 'types/injects/translator.type';

interface Props {
    widgetId?: string | null;
    decorative?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MeltingSpotWidget',
  props: {
    widgetId: { default: null },
    decorative: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const $t = inject('$t') as Translator;
const { load, bindDrawer, unbindDrawer, generateElementId } = useMeltingSpot();
const elementId = generateElementId();

onMounted(async () => {
    if (!props.decorative && props.widgetId) {
        await load();
        bindDrawer(elementId, props.widgetId);
    }
});

onBeforeUnmount(() => {
    unbindDrawer(elementId);
});

return (_ctx: any,_cache: any) => {
  const _component_CompassIcon = _resolveComponent("CompassIcon")!
  const _component_CompassTooltip = _resolveComponent("CompassTooltip")!

  return (!__props.decorative)
    ? (_openBlock(), _createBlock(_component_CompassTooltip, {
        key: 0,
        content: _unref($t).__('common.labels.need_help'),
        arrow: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            id: _unref(elementId),
            class: "meltingspot-widget"
          }, [
            _createVNode(_component_CompassIcon, {
              icon: "school",
              size: _ctx.CompassEnums.IconSize.SMALL
            }, null, 8 /* PROPS */, ["size"])
          ], 8 /* PROPS */, _hoisted_1)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["content"]))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, [
        _createVNode(_component_CompassIcon, {
          icon: "school",
          size: _ctx.CompassEnums.IconSize.SMALL
        }, null, 8 /* PROPS */, ["size"])
      ]))
}
}

})